export const addTrackingUrls = async(dataArray) => {
    if (!Array.isArray(dataArray)) {
      console.error('Expected array, got:', dataArray);
      return { data: [] };
    }
  
    const updated = dataArray.map(item => {
      const carrier = item["CARRIER"]?.toLowerCase() || '';
      const trackingNumber = item["TRACKING NUMBER"] || item["TRACKING_NUMBER"] || "";
      let trackingUrl = '';
  
      if (carrier.includes("usps")) {
        trackingUrl = `https://tools.usps.com/go/TrackConfirmAction?tRef=fullpage&tLc=2&text28777=&tLabels=${trackingNumber}%2C`;
      } else if (carrier.includes("fedex")) {
        trackingUrl = `https://www.fedex.com/fedextrack/?trknbr=${trackingNumber}&trkqual=12029~287439585538~FDEG`;
      } else if (carrier.includes("ups")) {
        trackingUrl = `https://www.ups.com/track?track=yes&trackNums=${trackingNumber}&loc=en_US&requester=ST/trackdetails`;
      }
  
      return {
        ...item,
        'TRACKING LINK': trackingUrl
      };
    });
  
    return { data: updated };
  };
  